import { Box, Button, Stack } from '@mui/material';

// Recruitment posters for #product-design. Captions are baked into the images
// so they can be dropped straight into Slack.
const MEMES = [
  {
    file: 'product-design-meme.jpg',
    alt: "A dog grinning by a fence while a horse grazes behind. This could be us, but you haven't joined #product-design",
  },
  {
    file: 'product-design-meme-waiting.jpg',
    alt: 'A dog behind some flowers. Just waiting for you to join #product-design',
  },
];

const ProductDesignMeme = () => (
  <Stack
    direction='row'
    spacing={6}
    useFlexGap
    sx={{
      minHeight: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      p: 4,
    }}
  >
    {MEMES.map(({ file, alt }) => (
      <Stack key={file} spacing={2} sx={{ alignItems: 'center' }}>
        <Box
          component='img'
          src={`/${file}`}
          alt={alt}
          sx={{ width: 400, maxWidth: '100%', display: 'block' }}
        />
        <Button variant='outlined' href={`/${file}`} download={file}>
          Download
        </Button>
      </Stack>
    ))}
  </Stack>
);

export default ProductDesignMeme;
